export enum ProjectSortTypes {
  Name = 'name',
  Budget = 'budget',
  GrossMargin = 'grossMargin',
  Costs = 'costs',
  InvoicedAmount = 'invoicedAmount',
  UninvoicedAmount = 'uninvoicedAmount',
  Spent = 'spent',
  Remaining = 'remaining',
}
